export const reportMissedPickUpDataEn = [
  {
    Question: `How do I report a missed pickup?`,
    Answer: `"For your home: Go to My Services in My WM and click on View ETA and Schedule to check for any alerts or a confirmation of service. If you have been missed for an unknown reason or your schedule status shows as service confirmed and you feel you were missed, click Report Missed Pickup. You will be provided with recovery expectations, our teams will be notified of your missed service and you will receive an email confirmation of your request. For your business: Go to My Services in My WM to verify that your pickup is still scheduled under View ETA and Schedule. If your schedule status shows as service confirmed and you feel you were missed, click Report Missed Pickup. Start a live chat for the fastest resolution. If chat is unavailable, you can Submit a Request. If you choose to submit a request, fill out the Report a Missed Pickup form and click Submit. You will receive a confirmation email after you submit your request.Note: When available, chat is the recommended form of communication for the fastest response time. If you require immediate recovery, please contact us."`,
  },
]

export const recyclingScheduledServiceOtherWeekDataEn = [
  {
    Question: `What is my recycling schedule if I'm serviced every other week?`,
    Answer: `:"Staying on top of your regularly scheduled service is easier than ever. Follow the steps below to check your recycling pickup schedule.

      1. Log in to your My WM profile
      
      2. Click My Services and select the account where you would like to check the schedule
      
      Note: Waste collection services typically occur between 5 a.m. and 6 p.m. local time. As a best practice, please place your container out by 5 a.m. the day of your service. Be aware that your driver may arrive within a one-hour window before or after your usual pickup time and this is not considered a missed pickup. Make sure the lid on your container is completely closed so that our drivers can service them safely.
      
      Please keep this schedule handy for you to use as a reminder of your recycling pickup services"`,
  },
]

export const whatIfPickUpDateOnHolidayDataEn = [
  {
    Question: `What if my next pickup date falls on a holiday?`,
    Answer: `:"Holidays may affect your regular pickup schedules. If your service day falls on or after a WM-observed holiday, your pickup may occur prior to your regularly scheduled service day or it may be delayed. For the latest updates on holiday schedule changes, visit our Notification Center. To stay up to date on the status of your account, enroll in email or text alerts.

    Holiday schedules are typically available 14 days prior to the holiday. If your next pickup falls on a holiday, please check for a possible change to your service day or time:
    
    1. Log in to your My WM profile
    
    2. Upcoming WM-observed holidays will appear on your main dashboard up to 14 days in advance"`,
  },
]

export const whatIsMyNextPixkupDataEn = [
  {
    Question: `When is my next pickup?`,
    Answer: `:Knowing when to expect your next pickup is step one to a successful service.

    1. Simply log in

    2. From the Dashboard, select the Manage My Services button in the My Services section

    3. If necessary, select the address and container you wish to track

    4. The container and its pickup schedule will appear. On the pickup day, a status indicator and estimated delivery window will display.

    Note: Waste collection services typically occur between 5 a.m. and 6 p.m. local time. Please place your container out by 5 a.m. the day of your service. Be aware that if your driver arrives before or after your exact pickup time this is not considered a missed pickup. Make sure the lid on your container is completely closed so that our drivers can service them safely`,
  },
]

export const howIRequestExtraPickUpDataEn = [
  {
    Question: `How do I request an extra pickup?`,
    Answer: `Producing more waste than usual? Schedule an extra pickup and we’ll handle the excess. Follow the steps below to learn how.

    1. Log in to your My WM profile
    
    2. From your My WM Dashboard, click Manage My Services
    
    3. Under What Can I Request? click Extra Pickup
    
    4. Make your selections and submit your request
    
    If you are unable to request an extra pickup via your My WM profile, contact us for further assistance.`,
  },
]

export const severeWeatherNotifiedDataEn = [
  {
    Question: `How do I know get notified and prepare for severe weather?`,
    Answer: `When weather-related issues, natural disasters or other serious situations occur, we work hard to keep you informed of how they may affect your service. Safety is our number one concern for our customers and for our employees.

    For the latest updates on possible service delays, interruptions and storm recovery in your area, visit our Notification Center. To stay up to date on the status of your account, enroll in email or text alerts.
    
    Note: Please keep storm debris separate from your normal household trash and recycling.
    
    &#8226 Storm debris is managed by your city, county, or area and will be performed by other contractors. You can refer to www.fema.gov for detailed instructions on debris collection.
    
    &#8226 Normal household trash and recycling will be collected by WM until a warning is issued.
    
    Extreme cold or warm weather can be a safety hazard and a disruption to your regular service. Here are a few tips on how prepare for proper waste disposal.
    
    Cold Weather Tips
    
    1. These common winter weather factors may disrupt your regular service:
    
    2. Plowed snow blocking access to your trash or recycling container
    
    3. The snow or ice around your container is too deep, preventing our truck's ability to access your container
    
    4. Steep hills or winding roads that have become icy, making it difficult for our drivers to navigate
    
    5. Poor visibility
    
    6. Non-plowed areas preventing our drivers from turning around
    
    7. Your trash or recycling container has been covered or buried in snow and is not visible to our driver
    
    8. Your trash or recycling container has been placed on or behind a snow mound and is inaccessible to our driver
    
    These tips will help ensure that your trash/recycling services run effectively during cold weather months:
    
    Keep the area in front and around your container salted and clear of snow and ice.
    
    Ensure all gates can be easily opened if your container is enclosed.
    
    Hot Weather Tips
    
    For personal and community safety, avoid placing these items in your trash:
    
    1. Flammable or combustible liquid including gasoline or oil-based paint
    
    2. Hazardous materials such as ammonia, bleach, pesticide, paint thinner and batteries
    
    3. Aerosol cans still containing propellants
    
    4. Hot ash from a fire pit, grill or fireplace
    
    Trash can give off unpleasant odor in hot or humid weather. Follow these tips to minimize odor:
    
    When throwing out meat and/or meat packaging, put it in a grocery bag and then into a kitchen bag. Make sure your container lid is completely closed to reduce any odor.
    
    1.Place all trash into a bag. This prevents liquid from settling at the bottom of a container and reduces odor and insect accumulation.
    
    2. Items that go into recycling containers should be washed out but not bagged.
    
    3. Keep your container lid closed and if possible, out of the sun.
    
    4. Rinse your residential container with hot water and soap after each pickup. Discard water onto gravel, grass area and or into the sink to avoid pollutants going into storm drains.
    
    5. Remove buildup at the bottom of your container using a sprayer or pressure washer.
    
    6. Use baking soda to absorb strong odors`,
  },
]

export const winteriseMyFarmDataEn = [
  {
    Question: `How do I best winterize my farm?`,
    Answer: `"Inspect and Inventory

    1. Review farm machinery, equipment, buildings, structure, walking paths, gates, and wiring
    
    2. Seal any leaks
    
    3. Check anti-freeze and hydraulic fluids
    
    4. Have a date to drain and clean pesticide equipment; use a light oil on these items especially seals to ensure year-on-year functionality
    
    5. Document your liquid pesticides, seeds, and growth formulas
    
    6. Mark inventory levels and store each in their recommended location
    
    Clean
    
    1. Debris, broken equipment, and other types of refuse
    
    2. Avoid pressure washing inside closed structures’ this can cut down on mold and mildew
    
    3. Dispose of expired items in a proper manner (see manufacturers instructions)
    
    Partner
    
    1. Getting to know your neighboring farms and going in with them on repair services will help share the cost of repair team visits.`,
  },
]

export const disposeStrashAfterStormDataEn = [
  {
    Question: `How do I dispose of trash and waste after a hurricane or storm?`,
    Answer: `"Ensuring the timely and safe removal of storm debris and service resumption is a highly coordinated effort. These steps will help ensure a smooth process:

    Separate regular household waste from storm debris.
    
    &#8226 Everyday items - including food, recyclables and other household waste should be disposed of normally
    
    &#8226 Storm debris - including tree limbs, soiled carpeting, damaged fencing and appliances should be placed curbside in separate piles
    
    Separating waste properly will allow us to collect household garbage more quickly and safely and help prevent odors and other safety hazards from impacting your surrounding area. Separation is also necessary to allow other firms to collect storm debris in accordance with arrangements made by local municipalities, counties or FEMA.
    
    We will restart curbside trash and recycling collection of normal household waste as soon as it is safe to do so.
    
    Visit our Notification Center webpage to check for the latest information on storm recovery within your community. To stay up to date on the status of your account, enroll in email or text alerts. We appreciate your partnership and patience as we restore your service after a storm.`,
  },
]

export const stayGreenDuringHolidayDataEn = [
  {
    Question: `How can I stay green during the holidays?`,
    Answer: `Shopping Tips:

    1. Consider giving no-waste gifts, such as downloadable music, electronically activated memberships or tickets.
    
    2. Buy products made from recycled or organic content, like bags and clothing.
    
    3. Consider no-waste wrapping options, like reusable bags, backpacks or purses.
    
    4. Keep in mind that foil, metallic or glitter accent wrapping paper isn't recyclable.
    
    Decorating Tips:
    
    1. Store your holiday decorations for reuse each year.
    
    2. If you upgrade your holiday decor, be sure to donate your old decor so other families can enjoy the spirit of the season.
    
    3. Make your own decorations from recycled materials.
    
    Celebration Tips:
    
    Send holiday greetings via e-mail or social media.
    
    When entertaining, use washable utensils, plates, glasses, cloth napkins, and reusable table covers.
    
    Have containers where guests can put recyclable, empty cans and bottles.
    
    Recycling Tips:
    
    1. Make sure your plastic shopping bags go back to local retail stores. Plastic bags don't belong in curbside recycling bins.
    
    2. For shipments coming to your house, be sure to break down your cardboard boxes before placing them in your recycling bin.
    
    3. Avoid putting bubble wrap and lights in your recycling bin, both of which can get tangled in recycling sorting equipment and create a safety hazard.
    
    4. For live Christmas trees, garland or wreaths, your local community might have recycling programs for yard waste or compost collection or drop-off programs.`,
  },
]

export const holidayAffectNewContainerDataEn = [
  {
    Question: `How will holidays affect delivery of my new container?`,
    Answer: `Waste Management works hard year-round so that delays do not occur. In some areas, however, major holidays may result in delays of a day or two. To manage your contact preferences, please visit your My WM Dashboard and enable notifications.`,
  },
]

export const delayDuringHolidayDataEn = [
  {
    Question: `What kind of delay might I expect during a holiday in my area?`,
    Answer: `We are working hard so that delays do not occur, but if that happens, you could be delayed up to 48 hours during the week of leave.

    Please login to your My WM account online to check for updates to your specific collection calendar.`,
  },
]

export const myServiceDuringMovingDataEn = [
  {
    Question: `I'm moving, what do I need to do with my service?`,
    Answer: `Congratulations on your move! Whether you would like to transfer your service, cancel or request new service, check below for next steps.

    To Transfer Your Service
    
    &#8226 Step 1: Check Service Availability in your new area
    
    &#8226 Step 2: Connect with Us to transfer your service
    
    To Cancel Your Service
    
    To cancel your WM service, please Contact Us via live chat, email, or phone. Please have your Customer ID and service address ready.
    
    Note: Canceling service prior to the end of a contract may result in early termination charges. Charges may vary depending on the area you’re in and the type of service you have.
    
    To Request New Service:
    
    If you are not a WM customer and would like to receive trash and recycling services from us, please visit wm.com/moving for more information and additional resources.`,
  },
]

export const changeContainerSizeDataEn = [
  {
    Question: `How can I change my container size?`,
    Answer: `If you find yourself needing a larger or small container, we’re here to help.

    1. Log in to your My WM profile
    
    2. Click Adjust Service
    
    3. Choose the account where you would like to make the change and select your new container
    
    4. Click Submit
    
    Note: Online container or service changes are not available for all customers. If you are able to adjust your service online, regulatory, service or other charges may also apply. Charges for service changes, such as container quantity increases or decreases, begin on the date of delivery and/or pickup`,
  },
]

export const changePickupFrequencyDataEn = [
  {
    Question: `How do I make changes to my service or pickup frequency?`,
    Answer: `With changing circumstances, you may want to adjust your service days/times or pickup frequency. Follow the steps below to learn if you are eligible to make online updates to your account.

    &#8226 Log in to your My WM profile Select Adjust Service.
    
    &#8226 Choose the account where you would like to make adjustments.
    
    &#8226 If you do not have the option to make your desired changes, please contact us. Make your selections and click submit.
    
    Note: Online service updates are not available in all areas. Charges may vary depending on the services selected and your service address. Regulatory, service or other charges may also apply.
    
    To make changes to your roll-off service or to schedule a roll-off haul for an existing account, please contact us via phone, email or live chat.`,
  },
]

export const serviceOnVacationHoldDataEn = [
  {
    Question: `How do I put my service on a seasonal or vacation hold?`,
    Answer: `If you have an upcoming vacation or an extended trip lasting a minimum of 30 days (maximum of 9 months), you may have the option to pause your service while not in use. Follow the steps below to learn how.

    1. Log in to your My WM account.
    
    2. If you have a single account, click Pause Service from your My WM Dashboard. If you have multiple accounts, click Adjust Service and select the account where you would like to pause your service. From there, click Pause Service.
    
    3. Select the date when you would like to stop service and the date when you would like your service to resume.
    
    4. Click Request Service Pause to complete your request. If you need to make changes after you’ve submitted your request, please call us at 1-866-909-4458 or contact us via live chat.
    
    Note: The request to pause service must be placed at least one business day in advance and cannot be requested in the past. Request your service be resumed at least three business days prior to your scheduled pickup day. Service pauses are not available for all customers in all areas`,
  },
]

export const cancelAServiceDataEn = [
  {
    Question: `How do I cancel a service?`,
    Answer: `We're sorry to hear that you want to cancel or stop a service. Please contact us, so that we may process this request.

    Please have your Customer ID and service address ready so that we can best assist you.
    
    Note: Canceling service prior to the end of a contract may result in early termination charges. Charges may vary depending on the area you’re in and the type of service you have.`,
  },
]

export const editCancelReturnRequestDataEn = [
  {
    Question: `How do I edit or cancel an empty and return request?`,
    Answer: `If you are a roll-off customer looking to edit or cancel an Empty and Return request:

    1. Log in to your My WM account
    
    2. Click My Services
    
    3. Select View All Empty & Returns and make your selections
    
    You will receive a confirmation email shortly after you submit your edit or cancel the request. If you have questions about your request, contact us.
    
    Note: This feature only applies to Empty and Return requests booked online. Locate the ticket and service date you wish to edit or cancel. You can only edit or cancel roll-off requests up to 24 hours prior to the service date. No same-day requests can be made online.`,
  },
]

export const cancelChaangeOrderDataEn = [
  {
    Question: `How do I cancel my service change order?`,
    Answer: `"Want to cancel or change your order after it’s been placed?

    If you have already requested to change your container size but would like to cancel, simply navigate to the My Services page within your My WM profile and choose the order you would like to cancel or change.
    
    Cancelations may be made up to 48 hours prior to delivery or pick up of a container. If you wish to cancel or change your order with less than 48 hours notice, please contact us. Please note that we cannot always accommodate requests made less than 48 hours in advance.`,
  },
]

export const getMyContainerRepairedDataEn = [
  {
    Question: `How do I get my WM container repaired`,
    Answer: `"If you have a My WM account:

    1. Go to My WM and log in if prompted.
    
    2. Make sure the account needing service is linked to your My WM profile:
    
    &#8226 Under My Accounts, choose Manage Accounts, then select and link the appropriate account.
    
    3. From your My WM dashboard, click the Manage My Services button under My Services.
    
    4. Make the appropriate selection from the Select Service dropdown.
    
    5. Under What Can I Request, choose Container Issue.
    
    6. Specify whether your container is missing (needs replacement) or damaged (needs repair).
    
    7. Click Submit Request.
    
    If you do NOT have a My WM account or you're unsure:
    
    1. Go to the wm.com home page and enter the address where container service is needed.
    
    2. If the address is eligible, you'll see a list of "quick links" appear.
    
    3. Choose the Request Container Repair/Replace option to go to the Container Issue page.
    
    4. Specify whether your container is damaged (needs repair) or missing (needs replacement).
    
    5. Fill in the required fields.
    
    6. Click Submit Request.
    
    Note: Charges may apply depending on the service"`,
  },
]

export const lockForMyContainerDataEn = [
  {
    Question: `Where can I get a lock for my container?`,
    Answer: `"WM has a variety of locks and styles available for commercial and business dumpsters.

    Locks can help prevent unauthorized use of your dumpster, which can help keep your costs down. Waste Management has 3 main lock varieties available for commercial dumpsters. They are Bar lock, Chain lock, and Gravity lock. There is an additional charge to add a lock to your container. Charges vary by area.
    
    To find information about container locks available in your area, please contact us.
    
    Note: Lockable residential containers are not available. If your lock is missing or broken, please contact us."`,
  },
]

export const containerDeliveryWorkDataEn = [
  {
    Question: `How does container delivery work?`,
    Answer: `Once we’ve confirmed the delivery date(s) for your new container(s), you’ll receive an email with service start details and tips for a successful delivery. A checklist for choosing a safe spot for your container(s) is below.

    If your delivery date has passed and you haven’t received your container, please contact us.
    
    For All Deliveries:
    
    Check above, below and around the space to ensure a safe environment.
    
    Ensure the area is accessible. Move any parked cars or obstructions and open or unlock gates to ensure the property is accessible. To set up lock service for an enclosure, please contact us or log in to My WM to explore options.
    
    If you have an onsite contact, ensure that they are available and informed of the delivery. Log in to My WM to manage contacts at your service location(s).Thank you for choosing Waste Management. A representative from Waste Management will contact you should we be unable to safely place your container in the location indicated.
    
    For Commercial Containers:
    
    If the container will be placed in an enclosure, please contact us if you have not already informed WM. Access areas must be at least 12 feet wide, and gates must be able to swing fully open.
    
    If the container will be placed off your property, make sure the placement has been approved by the city or any other owner.
    
    For Roll-Off Containers:
    
    Check the driving surface and pickup site – both must be level and strong enough to bear the weight of the container and truck.
    
    If the container will be placed off your property, make sure the placement has been approved by the city or any other owner.
    
    For Residential Carts
    
    Before your service starts, we will deliver a container to your normal trash and recycling pickup location, typically in the driveway or alley or at the front curb of your residence`,
  },
]

export const prepareForPickupDataEn = [
  {
    Question: `How can I prepare for pickups?`,
    Answer: `"For All Services:

    <ol><li>Take care of waste and recycling the right way. Put materials in the right containers; don’t overfill your containers.</li>
    
    <li> To view your next service date, log in to My WM and click View ETA under My Services. </li>
    
    <li> Set your preferences to stay in the know. Log in to My WM and opt in to text or email notifications to stay informed about your pickup schedules, weather delays and more. </li>
    
    <li> To change or cancel a scheduled service, please contact us 24 hours in advance.</li></ol>
    
    For Residential Service:
    
    <ol><li>Keep a lid on overages. All materials must fit in your cart(s), and the lid(s) must be fully closed. You may be charged if excess material is found on the ground, on top of a lid or prevents a lid from closing.</li>
    
    <li>Recycle right. Put materials in the right containers – never mix trash or recyclables. Visit our Recycle Right page for more information, rules and resources.</li>
    
    <li>Need to adjust your service or request an extra pickup? Contact us to explore your options.</li></ol>
    
    Set your communication preferences to stay informed. Log in to My WM and opt in to service updates by text or email.
    
    For Commercial Service:
    <ol><li>If your container has wheels, please ensure your container is placed in its designated pickup area and clear of any obstacles or overhead hazards like wires and branches.</li>
    <li>I Ensure the container is unlocked, if applicable. If you've placed a lock on your container, make sure it’s unlocked or removed on your service day to avoid a service interruption. To set up lock service with WM, please contact us or log in to My WM to explore options. </li>
    <li>I Keep a lid on overages. All materials must fit in your container(s), and lid(s) must be fully closed, if applicable. You may be charged if excess material is found on the ground, on top of a lid or prevents a lid from closing. </li>   
    <li>I Recycle right. Put materials in the right containers – never mix trash or recyclables. Visit our Recycle Right page for more information, rules and resources. </li>    
    <li>I Need to adjust your service or request an extra pickup? Contact us or log in to My WM to explore your options. </li> </ol>   
    For Roll-Off Service:
    
    When tossing items into your container, please ensure items are evenly distributed and don’t stick out over the rim. Always exclude any non-acceptable or hazardous materials and stay below the container’s maximum tonnage.
    
    Need an extra haul? Log in to My WM or contact us to schedule an extra haul`,
  },
]

export const handleOdourContainerDataEn = [
  {
    Question: `How should I handle odors coming from my container?`,
    Answer: `&#8226 Bag all your trash. This will help keep your container clean and free of leaks or spillage.

    &#8226 Partially fill the cart with water and add some bleach. Let it sit for a day or two then scrub it clean. The bleach will soak into the plastic and it will help to sanitize the container.
    
    &#8226 Order WM’s Odor Disposer, found here, to get rid of common household odors.`,
  },
]

export const containerRelocatedDataEn = [
  {
    Question: `How do I get my container relocated?`,
    Answer: `To request container relocation:

    &#8226 Log in to your My WM account
    
    &#8226 From My WM Dashboard, go to My Services under What Can I Request
    
    &#8226 Select Relocate
    
    &#8226 Complete all required fields on service form and submit
    
    Note: Make sure the area(s) for the bin relocation are accessible and free of obstructions and overhead wires. Make sure the driving surface to and around the pickup and drop-off site are strong enough to bear the weight of a dumpster and truck. A representative from Waste Management will contact you should we be unable to safely relocate your dumpster to the location indicated. There may be an additional charge to relocate your dumpster.
    
    If the dumpster will be placed in an enclosure and you have not already informed Waste Management, please contact us.`,
  },
]

export const permitContainerPlacementDataEn = [
  {
    Question: `Do you need a permit for your container placement?`,
    Answer: `Not all locations need a permit, but some Homeowner Associations, Improvement Districts, and Municipalities may require permitting. Be sure to check with your local governing authorities.
    Be ready to provide the size of your dumpster and expected placement and duration. They may also ask the time of day you will be filling, to see if you are working past any prescribed noise ordinance hours. The municipality may ask about your plans to keep the debris area secure and clean.`,
  },
]

export const reportStolenContainerDataEn = [
  {
    Question: `How do I report a lost or stolen container?`,
    Answer: `Let’s get your service back on track. To report your container as lost or stolen:
    1. Log in to your My WM account
    2. From the Dashboard, select Manage My Services
    3. Select the Container Issue and submit your reques.`,
  },
]
